const EditNoPhUserFieldsNoPs = (editingUser,handleCheckBox) => {
  const fields = [
    {
      item: {
        label: 'Nombre completo',
        name: 'fullName',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese el nombre completo',
          },
        ],
        initialValue: editingUser.fullName || ''
      },
      input: {  },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Número de teléfono',
        name: 'phoneNumber',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese un número de teléfono',
          },
        ],
        initialValue: editingUser.phoneNumber || ''
      },
      input: {  },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Email',
        name: 'email',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese un email',
          },
        ],
        initialValue: editingUser.email || ''
      },
      input: {  },
      inputTag: 'Input',
    },
    {
      item: {
        label: '¿Desea cambiar la contraseña?',
      },
      input: {
        onChange: handleCheckBox,
        id: 'adCheckbox',
      },
      inputTag: 'Checkbox',
    },
  ];
  return fields;
};

export default EditNoPhUserFieldsNoPs;
